import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDebounce } from 'use-debounce'

import { PureSelect } from '../../../../common/ui/pure-select/pure-select'
import { useGetCompanies } from '../../../../entities/dadata/hooks/dadata.hooks'
import { CompanyData } from '../../../../entities/dadata/types/dadata.types'

type SearchCompanyProps = {
  initialValue?: string
  label?: string
  colClass?: string
  required?: boolean
  error?: string
  onChange?: (value: CompanyData) => void
}

export const SearchCompany = ({ initialValue, onChange, label, colClass, required, error }: SearchCompanyProps) => {
  const { t } = useTranslation()
  const [value, setValue] = useState(initialValue)
  const [debouncedText] = useDebounce(value, 300)
  const { data: companies, isLoading } = useGetCompanies(debouncedText)

  const readyCompanies = useMemo(() => {
    if (!companies?.suggestions) return []

    return companies.suggestions.map((company) => ({
      value: company.data.inn,
      display: company.value,
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', padding: '4px 0' }}>
          <span style={{ fontWeight: 600, fontSize: '14px', lineHeight: '20px' }}>{company.value}</span>
          <span>
            <span style={{ fontSize: '12px', color: '#8c8c8c' }}>
              {t('common.inn')}: {company.data.inn}
            </span>
            <span style={{ fontSize: '12px', color: '#8c8c8c' }}>
              {t('common.inn')}: {company.data.ogrn}
            </span>
          </span>
        </div>
      ),
    }))
  }, [companies?.suggestions])

  const handleChangeCompany = (inn: string) => {
    const company = companies?.suggestions.find((company) => company.data.inn === inn)
    setValue(company?.value ?? '')
    if (company) {
      onChange?.(company)
    }
  }

  const handleSearch = (searchValue: string) => {
    setValue(searchValue)
  }

  return (
    <PureSelect
      colClass={colClass}
      error={error}
      filterOption={false}
      label={label}
      loading={isLoading}
      onChange={handleChangeCompany}
      onSearch={handleSearch}
      optionLabelProp="display"
      options={readyCompanies}
      placeholder=""
      required={required}
      searchValue={value}
      value={undefined}
      showSearch
    />
  )
}
